import { WhatsappQualityRating } from "@jugl-web/rest-api";
import { TFunction } from "@jugl-web/utils";
import { CRMStatus } from "../components/CRMStatusPill";

export const getQualityRatingDetails = (
  rating: WhatsappQualityRating,
  t: TFunction
): { description: React.ReactNode; status: CRMStatus } => {
  const qualityRatingDetailsMap: Record<
    WhatsappQualityRating,
    { description: React.ReactNode; status: CRMStatus }
  > = {
    GREEN: {
      description: t({
        id: "client-support-page.quality-rating-high-description",
        defaultMessage:
          "Great Job! Communication with Clients is on a higher level",
      }),
      status: "high",
    },
    YELLOW: {
      description: t({
        id: "client-support-page.quality-rating-medium-description",
        defaultMessage:
          "There is a place for improvement, but overall your rate is good",
      }),
      status: "medium",
    },
    RED: {
      description: t({
        id: "client-support-page.quality-rating-low-description",
        defaultMessage:
          "Looks like Clients is not satisfied with communication. Please read Tools & Tips to improve communication",
      }),
      status: "low",
    },
    UNKNOWN: {
      description: t({
        id: "client-support-page.quality-rating-unknown-description",
        defaultMessage:
          "There is no conversations yet to rate the quality of your responses",
      }),
      status: "unknown",
    },
  };

  return qualityRatingDetailsMap[rating];
};
